<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>检测信息</el-breadcrumb-item>
			<el-breadcrumb-item>工艺信息</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="dateRange" />
				</el-form-item>
				<el-form-item label="车间选择">
					<el-select v-model="workshop" clearable placeholder="车间选择">
						<el-option v-for="item in workshops" :key="item.value" :label="item.label" :value="item.value"> </el-option>
					</el-select>
				</el-form-item>

				<el-form-item>
					<el-button type="info">工单查询</el-button>
				</el-form-item>
			</el-form>
		</div>

		<div>
			<el-table border v-loading="tableLoading" :data="tableData" style="width: 100%">
			
				<el-table-column type="index" label="序号" width="50"> </el-table-column>
				<el-table-column prop="jobOrderCode" label="工单号"> </el-table-column>
				<el-table-column prop="begin_time_str" label="开始时间" width="180"> </el-table-column>
				<el-table-column prop="end_time_str" label="预计结束时间" width="180"> </el-table-column>
				<el-table-column prop="jobOrder.total_len" label="工单总米数" width="100"> </el-table-column>
				<el-table-column prop="jobOrder.roll_len" label="每卷米数" width="100"> </el-table-column>
				<el-table-column prop="jt_name" label="生产机台" width="120"> </el-table-column>
				<el-table-column label="查看" width="200" fixed="right">
					<template slot-scope="scope">
						<el-button @click="handViewTech(scope.row)" type="text" size="small">查看工艺信息</el-button>
						<el-divider direction="vertical"></el-divider>
						<el-button @click="handleViewColorInfo(scope.row)" type="text" size="small">查看颜色信息</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!--分页-->
			<el-pagination layout="sizes, prev, pager, next, total" :page-count="totalPage" :page-sizes="[10, 50, 100, 200]" :size="pageSize" @current-change="handleCurrentChange" @size-change="handleSizeChange"> </el-pagination>
		</div>
	</div>
</template>

<script>
	import DateRange from '@/components/DateRangePicker'
	import { getTechRequest } from '@/network/requests/tech'
	import defectService from '@/service/defectService'
	import dictionaryData from '@/service/dictionaryData'
	export default {
		components: {
			DateRange,
		},
		data() {
			return {
				dateRange: [],
				tableData: [],
				tableLoading: false,
				workshop: {},
				workshops: [],
				pageIndex: 1,
				pageSize: 10,
				totalPage: 1,
			}
		},
		methods: {
			
			showDetails() {
				this.$router.push({ name: 'CraftView' })
			},
			async query() {
				var result = await defectService.getDefectStatList(this.pageIndex, this.pageSize)
				this.tableData = result.data
				this.totalPage = result.totalPage
				this.tableLoading = false
			},
			handleCurrentChange(page) {
				this.tableLoading = true
				this.pageIndex = page
				this.query()
			},
			handleSizeChange(size) {
				this.tableLoading = true
				this.pageSize = size
				this.pageIndex = 1

				this.query()
			},
			handViewTech(row) {},
			handleViewColorInfo(row) {},
		},
		async created() {
			this.tableLoading = true
			this.workshops = await dictionaryData.getWorkshops()
			await this.query()
		},
	}
</script>

<style></style>
